const en = require('./en');
const ar = require('./ar');

module.exports = { en:en, ar:ar }


// WEBPACK FOOTER //
// ./src/locales/index.js